export default __webpack_public_path__ + "static/media/who-let-the-dogs.e24b1359.mp3";